/// <reference path="../../include.ts" />

namespace gpx_visualizer_phase2 {

	import EventDispatcher = alm.event.EventDispatcher;

	export class ProgressManager extends EventDispatcher {

		// --------------------------------------------------
		//
		// CONSTRUCTOR
		//
		// --------------------------------------------------

		private constructor() {
			super();

			this.range = new ProgressRange();
			this.speed = 1;
			this.isPlaying = false;
			this.information = Information.getInstance();
		}





		// --------------------------------------------------
		//
		// METHOD
		//
		// --------------------------------------------------

		public setRange(from:number, to:number):void {
			this.range.setRange(from, to);
		}

		public setSpeed(speed:number):void {
			trace('[ProgressManager] speed :', speed);
			this.speed = speed;
		}

		public getCurrent():number {
			return this.range.getCurrent();
		}

		public getCurrentRatio():number {
			return this.range.getCurrentRatio();
		}

		public getElapsed():number {
			return this.range.getElapsed();
		}

		public play():void {
			if (this.isPlaying) return;
			this.isPlaying = true;
			trace('[ProgressManager] play');
			this.lastUpdatedTime = Date.now();
			this.dispatchEvent(new ProgressManagerPlayEvent(ProgressManagerPlayEvent.CHANGE, this, this.isPlaying));

			const ratio = this.range.getCurrentRatio();
			if (ratio == 0) {
				this.dispatchEvent(new ProgressManagerProgressEvent(ProgressManagerProgressEvent.START, this, ratio));
			}
		}

		public stop():void {
			if (!this.isPlaying) return;
			this.isPlaying = false;
			trace('[ProgressManager] stop');
			this.dispatchEvent(new ProgressManagerPlayEvent(ProgressManagerPlayEvent.CHANGE, this, this.isPlaying));
		}

		public toggle():void {
			this.isPlaying ? this.stop() : this.play();
		}

		public reset():void {
			trace('[ProgressManager] reset');
			this.stop();
			this.range.reset();
		}

		public update():void {
			// seek forward
			if (this.isPlaying && !this.range.getIsFinished()) {
				const currentTime:number = Date.now();
				const deltaTime:number = currentTime - this.lastUpdatedTime;
				this.range.progressByValue(deltaTime * this.speed);
				this.lastUpdatedTime = currentTime;
				this.dispatchEvent(new ProgressManagerSeekEvent(ProgressManagerProgressEvent.PROGRESS, this, this.range.getCurrentRatio()));
				if (this.range.getIsFinished()) {
					this.stop();
					this.dispatchEvent(new ProgressManagerSeekEvent(ProgressManagerProgressEvent.COMPLETE, this, this.range.getCurrentRatio()));
				}
			} else if (this.isPlaying && this.range.getIsFinished()) {
				this.stop();
				this.dispatchEvent(new ProgressManagerSeekEvent(ProgressManagerProgressEvent.COMPLETE, this, this.range.getCurrentRatio()));
			}
		}

		public seekByRatio(ratio:number) {
			//trace('[ProgressManager] seekByRatio', ratio);
			//const isPrevFinished = this.range.getIsFinished();
			this.range.seekByRatio(ratio);
			this.dispatchEvent(new ProgressManagerSeekEvent(ProgressManagerSeekEvent.SEEK, this, this.range.getCurrentRatio()));
			//if (!isPrevFinished && this.range.getIsFinished()) {
			//	this.dispatchEvent(new ProgressManagerSeekEvent(ProgressManagerProgressEvent.COMPLETE, this, this.range.getCurrentRatio()));
			//}
		}

		public getIsPlaying():boolean {
			return this.isPlaying;
		}

		public getIsFinished():boolean {
			return this.range.getIsFinished();
		}

		public getSpeed():number {
			return this.speed;
		}





		// --------------------------------------------------
		//
		// VARIABLE
		//
		// --------------------------------------------------

		public static getInstance():ProgressManager { return this.instance || (this.instance = new ProgressManager()) };
		private static instance:ProgressManager = null;

		private range:ProgressRange;
		private speed:number;
		private isPlaying:boolean;
		private lastUpdatedTime:number;
		private information:Information;
	}
}
